module.exports = __webpack_public_path__ + "media/total-control-x_sm.3c480354.mp4";